import React from 'react';
import { useAuth } from '@/context/AuthContext';
import {
  isKRRole,
  isAgencyPrincipal,
  isAgencyContext,
  isAgent,
  isAccountingRole,
} from '@/lib/utils';
import { KRDashboard } from '@/components/dashboard/KRDashboard';
import { AgencyDashboard } from '@/components/dashboard/AgencyDashboard';
import { AgentDashboard } from '@/components/dashboard/AgentDashboard';
import { AccountingDashboard } from '@/components/dashboard/AccountingDashboard';

/**
 * DashboardPage — thin role router.
 *
 * Phase 20.2 split the previous 705-line role-branching monolith into four
 * role-specific dashboards under `/components/dashboard/`. This file now
 * only decides WHICH dashboard to render. All data loading, permissions,
 * and rendering live inside each role component.
 *
 * Ordering rules (preserve pre-refactor behavior exactly):
 *   1. Pure Agents (Agent role, not KR, not Principal) → AgentDashboard.
 *   2. KR roles (SuperAdmin / Admin / Ops)             → KRDashboard.
 *   3. Accounting-only users                           → AccountingDashboard.
 *   4. Agency context (Principal or Agency User)       → AgencyDashboard.
 *   5. Fallback                                        → AgentDashboard.
 */
export default function DashboardPage() {
  const { user } = useAuth();

  if (isAgent(user) && !isKRRole(user) && !isAgencyPrincipal(user)) {
    return <AgentDashboard />;
  }
  if (isKRRole(user)) return <KRDashboard />;
  if (isAccountingRole(user)) return <AccountingDashboard />;
  if (isAgencyContext(user)) return <AgencyDashboard />;
  return <AgentDashboard />;
}
